import { ChangeDetectorRef, Component } from '@angular/core';
import { PayCode } from 'src/shared/models/pay-code';
import { TimePayCodeMappingService } from 'src/shared/services/time-pay-code-mapping.service';
import { MappingComponentBase } from 'src/shared/admin-page/mapping-page-base.component';

@Component({
    selector: 'smt-time-pay-code-mapping',
    templateUrl: './time-pay-code-mapping.component.html',
    styleUrls: ['./time-pay-code-mapping.component.scss']
})

export class TimePayCodeMappingComponent extends MappingComponentBase {
    sortOptions: string[] = ["Client Time Pay Code", "Last Modified Date", "Last Modified By"];

    constructor(
        public _timePayCodeMappingService: TimePayCodeMappingService,
        protected _changeDetector: ChangeDetectorRef) {
        super(_timePayCodeMappingService, _changeDetector);
    }

    public getSortOptions(): string[] {
        return this.sortOptions;
    }

    getDisplayName(mapping: PayCode): string {
        return mapping.timePayCode;
    }
}